import { Navigate } from "@tanstack/react-router";

/**
 * Router-wide fallback for any unmatched route.
 *
 * Old iOS home-screen PWA installs cold-launch the legacy `start_url` "/projects"
 * (from the previous Next.js app), which no longer exists in this router. iOS never
 * re-reads the manifest for an installed PWA, so those installs can't be re-pointed —
 * we handle it on the app side instead. Redirecting every unmatched route to the
 * projects home ("/") makes those installs (and any stale link/bookmark) land
 * correctly, replacing TanStack Router's default bare "Not Found" screen.
 *
 * `replace` keeps the dead URL out of history. No redirect loop: "/" is a real route.
 */
export function NotFoundRedirect() {
  return <Navigate to="/" replace />;
}
